import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import account from "./modules/account";
import admins from "./modules/admins";
import batteries from "./modules/batteries";
import cycles from "./modules/cycles";
import projects from "./modules/projects";
import batteryFeatures from "./modules/batteryFeatures";
import i18n from "@/helpers/i18n";
import mainProjects from "./modules/mainProjects";
import authorize from "./modules/authorize";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appSettings: {
      projectName: i18n.t("appName"),
      tokenTime: 1,
    },
  },
  getters: {
    getAppSettings: (state) => {
      return state.appSettings;
    },
  },
  mutations: {},
  actions: {},
  modules: {
    batteryFeatures,
    authorize,
    app,
    account,
    admins,
    batteries,
    cycles,
    projects,
    mainProjects,
  },
});
